"use client";
import { createContext } from "react";
//#region packages/@mantine/core/src/components/Menu/MenuSub/MenuSub.context.tsx
const SubMenuContext = createContext(null);
//#endregion
export { SubMenuContext };

//# sourceMappingURL=MenuSub.context.mjs.map